import { Component, Inject, forwardRef, OnInit } from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { connectHierarchicalMenu } from 'instantsearch.js/es/connectors';
import { CatalogWidgetDirective, IBaseItem } from '../catalog-widget';
import { parseItemLabelAndId, checkRouteParameters } from '@app/shared/components/catalog/services/filters.service';

export interface IHierarchicalItem extends IBaseItem {
  data: IHierarchicalItem[];
}

@Component({
  selector: 'vc-catalog-widget-hierarchical-menu',
  templateUrl: './catalog-widget-hierarchical-menu.component.html',
  styleUrls: ['./catalog-widget-hierarchical-menu.component.scss', '../catalog-widgets.scss']
})
export class CatalogWidgetHierarchicalMenuComponent extends CatalogWidgetDirective implements OnInit {
  public isShowingMore = false;

  state: {
    createURL: (string) => string;
    items: IHierarchicalItem[];
    refine: (string) => void;
    canToggleShowMore: boolean;
    isShowingMore: boolean;
    toggleShowMore: () => {};
  };

  constructor(@Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent) {
    super('CatalogWidgetHierarchicalMenuComponent');
  }

  ngOnInit() {
    this.createWidget(connectHierarchicalMenu, {
      attributes: this.options.facet,
      showParentLevel: true,
      limit: this.options.limit
    });
    super.ngOnInit();
  }

  get items(): IHierarchicalItem[] {
    const transformedItems = [];
    const filterUrlList = this.getUrlList();
    for (const item of this.state.items || []) {
      const transformedItem = {
        ...item,
        ...parseItemLabelAndId(item.label, false, null, filterUrlList),
        data: []
      };

      for (const subItem of item.data || []) {
        transformedItem.data.push({
          ...subItem,
          ...parseItemLabelAndId(subItem.label, false, null, filterUrlList)
        });
      }

      if (checkRouteParameters(this.options.routeParameters, this.pageRouteParameter, transformedItem)) {
        transformedItems.push(transformedItem);
      }
    }

    return transformedItems;
  }

  public toggleShowMore() {
    this.isShowingMore = !this.isShowingMore;
  }
}
